import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Box, themeGet } from '@lightspeed/flame/Core';
import { Modal, ModalBody, ModalFooter } from '@lightspeed/flame/Modal';

export const StyledModal = styled(Modal)`
  height: 516px;
  width: 50%;
  max-width: 600px;
  @media screen and (max-width: 992px) {
    max-width: 80%;
  }
`;

export const StyledModalBody = styled(ModalBody)`
  padding: 0px !important;
  overflow: auto;
  margin-bottom: -1px;
`;

export const StyledModalFooter = styled(ModalFooter)`
  z-index: 1;
`;

export const StyledItemDescription = styled(Box)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const UnstyledButton = styled(Button)`
  background: none;
  background-image: none;
  outline: none;
  border: none;
  box-shadow: none;
  padding: 0;
  color: ${themeGet('colors.blue-500')};
  min-height: 0;
  text-decoration: none;

  &:focus,
  &:hover,
  &:active {
    color: ${themeGet('colors.blue-500')};
    background: none;
    background-image: none;
    outline: none;
    border: none;
    box-shadow: none;
    text-decoration: underline;

    svg path:last-child {
      fill: ${themeGet('colors.maple-500')};
    }
  }

  svg {
    fill: ${themeGet('colors.white')};
  }
`;
